module.exports = __webpack_public_path__ + "images/mdj/members/resume/preview/preview_btn02-2f8642e74822d58e987a0aed5cbbba47.jpg";